export default __webpack_public_path__ + "static/media/rev_f_standalone.a59046fe.webp";